import { getApiUrl, getWebsocketBaseUrl } from "Config";
import {
  signIn as cognitoSignIn,
  signOut as cognitoSignOut,
  fetchAuthSession,
  getCurrentUser,
} from "aws-amplify/auth";
import axios from "axios";

type Nullable<T> = T | null | undefined;

const local = import.meta.env?.VITE__LOCAL_LOGIN === "true";
let localTestUser: Nullable<string>;

export const signIn = async (
  username: string,
  password: string,
  localOverride?: boolean,
  localOverrideUrl?: string,
): Promise<void> => {
  if (local || localOverride) {
    const url = localOverrideUrl || getApiUrl();
    // bare axios instance to avoid the default interceptors
    const resp = await axios.create().get(`${url}/get_test_user`, {
      params: { email_address: username },
    });
    window.localStorage.setItem("localUser", JSON.stringify(resp.data));
    localTestUser = resp.data;
  } else {
    await cognitoSignIn({
      username,
      password,
      options: { authFlowType: "USER_PASSWORD_AUTH" },
    });
  }
};

export const currentUser = (): Promise<unknown> => {
  if (local) {
    return new Promise((resolve, reject) => {
      if (localTestUser) {
        resolve(localTestUser);
      } else {
        const localUser = window.localStorage.getItem("localUser");

        if (localUser) {
          try {
            localTestUser = JSON.parse(localUser);
            resolve(localTestUser);
          } catch {
            reject("Could not parse current user");
          }
        }
        reject("No current user");
      }
    });
  } else {
    return getCurrentUser();
  }
};

export const getAuthHeader = async (): Promise<Record<string, string>> => {
  if (local) {
    return new Promise((resolve, reject) => {
      if (localTestUser) {
        resolve({ "X-Test-User": localTestUser });
      } else {
        reject("No current user");
      }
    });
  } else {
    return {
      Authorization: `Bearer ${await getAccessJWT()}`,
    };
  }
};

export const getWebSocketURL = async (): Promise<string> => {
  return `${getWebsocketBaseUrl()}?authToken=${await getAccessJWT()}`;
};
export const getAccessJWT = async (): Promise<string> => {
  const jwt = (await fetchAuthSession()).tokens?.accessToken?.toString();
  if (!jwt) {
    throw new Error("No current session");
  }
  return jwt;
};

export const signOut = (): Promise<void> => {
  if (local) {
    window.localStorage.removeItem("localUser");

    return new Promise((resolve) => {
      localTestUser = undefined;
      resolve();
    });
  } else {
    return cognitoSignOut();
  }
};
